import { apiClient } from "../apiClient";

const CONG_THUC_LOP_HOC_PHAN_ENDPOINT = 'cong-thuc-lop-hoc-phan';
export const congThucLopHocPhanApi = {
    SysAuto: (ky_dang_ky: number, id_lop_tcs: number[]) => apiClient.patch(`${CONG_THUC_LOP_HOC_PHAN_ENDPOINT}/sys-auto/ky-dang-ky/${ky_dang_ky}`, id_lop_tcs),
}
